import CoreComponent from '../../core/CoreComponent.vue';
export default {
  extends: CoreComponent,
  mounted() {},
  beforeUnmount() {},
  methods: {}
};